export enum LoadingStatus {Init, Loading, Success, Fail, Wait};

export interface StatusProps {
    setResult: (success: boolean, data: any, error: any) => void;
};